import React from 'react';
import moment from 'moment';
import { Button } from 'antd';
import cn from 'classnames';
import {
  setCalendarData,
  setCalendarSheet,
  setLocalTask,
  setView,
} from '../../store/actions/calendarActions';
import { states } from '../../constants/states';
import { useCalendarDispatch, useCalendarState } from '../../context/CalendarContext';
import commonStyles from '../../Calendar.module.scss';
import styles from './ChangeViewButton.module.scss';

const ChangeViewButton = ({ text, view }) => {
  const dispatch = useCalendarDispatch();

  const { view: currentView, localTask, state } = useCalendarState();

  const handleClick = () => {
    if (currentView !== view) {
      if (localTask) {
        dispatch(setCalendarSheet(moment(localTask.fromDate)));

        if (state === states.addTask) {
          dispatch(setLocalTask(null));
        }
      }

      dispatch(setView(view));
      dispatch(setCalendarData([]));
    }
  };

  return (
    <Button
      onClick={handleClick}
      className={cn(styles.root, commonStyles.button, {
        [styles.active]: currentView === view,
      })}
    >
      {text}
    </Button>
  );
};

export default ChangeViewButton;
